import { Axios } from "./axios";
import {
  STATISTIC,
  HOST_API,
  AUTH_OUT,
  AUTH_REFRESH_TOKEN,
  AUTH_CHECK_SUPER,
  LOGIN_RECEIVE_CITIZEN_PASSWORD,
  SSO_AUTH_API_CITIZEN_LOGOUT,
} from "../api";

function authSignOut() {
  return Axios("get", `${SSO_AUTH_API_CITIZEN_LOGOUT}`);
}

function authRefreshToken() {
  return Axios("get", `${HOST_API}${AUTH_REFRESH_TOKEN}`);
}

function authCheckSuper(account) {
  return Axios("post", `${HOST_API}${AUTH_CHECK_SUPER}`, { usr: account });
}
//
function authReceiveCitizenPassword(email) {
  return Axios("post", `${LOGIN_RECEIVE_CITIZEN_PASSWORD}`, {
    email: email,
  });
}
//receive-citizen-password
export {
  authSignOut,
  authRefreshToken,
  authCheckSuper,
  authReceiveCitizenPassword,
};
